import axios from 'axios'
import CONFIG from '@/config'

import bus from '@/eventbus'
import Messages from '@/helpers/message-helper'

const BASE_URL = `${CONFIG.API_PATH}`
import store from '@/store/index'

async function setAuthHeader() {
	const session = await store.dispatch('getSession')
	const { jwtToken} = session.idToken
	axios.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`
}

function attributesToProperties(attributes) {
	// Transform Cognito attributes to user object properties
	return attributes.reduce((acc, attribute) => {
		const {
			Name,
			Value
		} = attribute

		acc[Name] = Value
		return acc
	}, {})
}

function propertiesToAttributes(properties) {
	// Transform user object properties to Cognito attributes
	var attributes = []
	for (const [property, value] of Object.entries(properties)) {
		if (property != 'Username' && property != 'sub')
			attributes.push({
				Name: property,
				Value: value
			})
	}

	return attributes
}

const UserService = {
	getAll: async () => {
		bus.$emit('loading-show')

		await setAuthHeader()
		const URL = `${BASE_URL}/users`

		try {
			let result = await axios.get(URL)
			let users = []
			let paginationToken = result.data.PaginationToken
			users = users.concat(result.data.Users)
			do {
				result = await axios.get(`${BASE_URL}/users/page/${paginationToken}`)
				users = users.concat(result.data.Users)
				paginationToken = result.data.PaginationToken
			} while (paginationToken !== undefined)
			
			return users.map(user => {
				user.Attributes = attributesToProperties(user.Attributes)
				return user
			})

		} catch (error) {
			throw error
		} finally {
			bus.$emit('loading-close')
		}
	},

	resetPassword: async username => {
		const URL = `${BASE_URL}/users/reset/${username}`
		let result = await axios.post(URL)
		return result
	},

	addUser: async data => {
		Messages.showSaving()

		const { Username, Attributes: _attributes } = data
		const Attributes = propertiesToAttributes(_attributes)

		await setAuthHeader()
		const URL = `${BASE_URL}/users`

		try {
			let result = await axios.post(URL, {
				Username,
				Attributes
			})

			if (result.response && result.response.status == 500)
				throw new Error(result.response.data.errorMessage)

			Messages.showSuccess('saved')

			const resultUser = result.data.User
			resultUser.Attributes = attributesToProperties(resultUser.Attributes)
			return resultUser
		} catch (error) {
			Messages.showError(error)
			throw error
		}
	},

	getUserGroups: async () => {
		await setAuthHeader()
		const URL = `${BASE_URL}/usergroups`

		try {
			let result = await axios.get(URL)
			if (result.response && result.response.status == 500)
				throw new Error(result.response.data.errorMessage)

			Messages.showSuccess('loaded')
			return result.data.Groups
		} catch (error) {
			Messages.showError(error)
			throw error
		}
	},

	getGroupsByUser: async Username => {
		// Messages.showLoading()

		await setAuthHeader()
		const URL = `${BASE_URL}/users/groups/${Username}`

		try {
			let result = await axios.get(URL)
			if (result.response && result.response.status == 500)
				throw new Error(result.response.data.errorMessage)
			return result.data.Groups
		} catch (error) {
			Messages.showError(error)
			throw error
		}
	},

	saveUser: async data => {
		Messages.showSaving()

		const { Username, Attributes: _attributes } = data
		const Attributes = propertiesToAttributes(_attributes)


		await setAuthHeader()
		const URL = `${BASE_URL}/users/${Username}`

		try {
			let result = await axios.put(URL, Attributes)

			if (result.response && result.response.status == 500)
				throw new Error(result.response.data.errorMessage)

			Messages.showSuccess('saved')

			return true
		} catch (error) {
			Messages.showError(error)
			throw error
		}
	},

	removeUser: async username => {
		Messages.showSaving()
		const URL = `${BASE_URL}/users/remove/${username}`

		await setAuthHeader()

		try {
			let result = await axios.post(URL)

			if (result.response && result.response.status == 500)
				throw new Error(result.response.data.errorMessage)

			Messages.showSuccess('removed')
			return result
		} catch (error) {
			Messages.showError(error)
			throw error
		}
	},

	async addToGroup(Username, group) {
		Messages.showSaving()

		await setAuthHeader()
		const URL = `${BASE_URL}/users/groups/add/${Username}`

		try {
			let result = await axios.put(URL, group)
			if (result.response && result.response.status == 500)
				throw new Error(result.response.data.errorMessage)

			Messages.showSuccess('saved')
			return result
		} catch (error) {
			Messages.showError(error)
			throw error
		}
	},

	async removeFromGroup(Username, group) {
		Messages.showSaving()

		await setAuthHeader()
		const URL = `${BASE_URL}/users/groups/remove/${Username}`

		try {
			let result = await axios.put(URL, group)
			if (result.response && result.response.status == 500)
				throw new Error(result.response.data.errorMessage)

			Messages.showSuccess('saved')
			return result
		} catch (error) {
			Messages.showError(error)
			throw error
		}
	},

	attributesToProperties,
	propertiesToAttributes
}

export default UserService